module.exports = __webpack_public_path__ + "img/gate_skipped.1214541.svg";